import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import EditIcon from "@material-ui/icons/Edit";
import {
  TableRow,
  TableCell,
  Checkbox,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import PostAddIcon from "@material-ui/icons/PostAdd";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";

import { TableSpanLoader } from "../../../tableSpanLoader/TableSpanLoader";
import { useHistory, useRouteMatch } from "react-router-dom";

export const RecruitmentLists = React.memo((props) => {
  let { url } = useRouteMatch();
  const history = useHistory();
  const {
    data,
    loading,
    stableSort,
    getComparator,
    order,
    orderBy,
    page,
    rowsPerPage,
    isSelected,
    handleClick,
    isCheckbox,
    handleNoteRequest,
  } = props;

  // ---------- LOADING ----------

  let tableLists = <TableSpanLoader col={12} loader={true} />;

  // ---------- DATA ----------

  if (!loading)
    tableLists = (
      <>
        {data.length === 0 ? (
          <TableSpanLoader
            col={12}
            loader={false}
            message="Recruitments not available!"
          />
        ) : (
          stableSort(data, getComparator(order, orderBy)).map((row, index) => {
            const isItemSelected = isSelected(row._id);

            const labelId = `enhanced-table-checkbox-${index}`;

            // Languages from services array
            const languages =
              row?.services?.map((s) => s.language)?.join(", ") || "-";

            const dialects =
              row?.services?.map((s) => s.dialect)?.join(", ") || "-";

            const isDuplicate = row?.status === "Duplicate" ? true : false;

            return (
              <TableRow
                hover
                role="checkbox"
                key={row._id}
                selected={isItemSelected}
                tabIndex={-1}
                style={{ backgroundColor: isDuplicate ? "#f8d7da" : "inherit" }}
              >
                {/* Checkbox */}

                {isCheckbox && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected}
                      onClick={(event) => handleClick(event, row._id)}
                      inputProps={{
                        "aria-labelledby": labelId,
                      }}
                    />
                  </TableCell>
                )}

                {/* Recruitment ID */}

                <TableCell align="left">{row?.recId || "-"}</TableCell>

                {/* Received Date */}

                <TableCell align="left">
                  {row?.date ? moment(row.date).format("DD/MM/YYYY") : "-"}
                </TableCell>

                {/* Candidate Name */}

                <TableCell align="left">{row?.name || "-"}</TableCell>

                {/* Email */}

                <TableCell align="left">{row?.email || "-"}</TableCell>

                {/* Telephone */}

                <TableCell align="left">{row?.contactNumber || "-"}</TableCell>

                {/* Gender */}

                <TableCell align="left">{row?.gender || "-"}</TableCell>

                {/* Nationality */}

                <TableCell align="left">{row?.nationality || "-"}</TableCell>

                {/* Languages */}

                <TableCell align="left">{languages}</TableCell>

                {/* Dialects */}
                <TableCell align="left">{dialects}</TableCell>

                {/* Status */}

                <TableCell align="left">{row?.status || "-"}</TableCell>

                {/* Action */}
                <TableCell align="left">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Tooltip title={`Edit: ${row?.name}`}>
                      <IconButton
                        style={{ cursor: "pointer" }}
                        aria-label="edit"
                        size="small"
                        onClick={() => history.push(`${url}/edit/${row._id}`)}
                      >
                        <EditIcon fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title={`Notes: ${row.recId}`}>
                      <IconButton
                        size="small"
                        onClick={() => handleNoteRequest(row?._id)}
                      >
                        {row?.recruitmentNotes?.length === 0 ? (
                          <PostAddIcon fontSize="small" color="primary" />
                        ) : (
                          <PlaylistAddCheckIcon
                            fontSize="small"
                            color="primary"
                          />
                        )}
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            );
          })
        )}
      </>
    );

  return <>{tableLists}</>;
});

RecruitmentLists.propTypes = {
  data: PropTypes.array.isRequired,

  loading: PropTypes.bool.isRequired,

  stableSort: PropTypes.func.isRequired,

  getComparator: PropTypes.func.isRequired,

  order: PropTypes.string.isRequired,

  orderBy: PropTypes.string.isRequired,

  page: PropTypes.number.isRequired,

  rowsPerPage: PropTypes.number.isRequired,

  isSelected: PropTypes.func.isRequired,

  handleClick: PropTypes.func.isRequired,
};
